export async function getOktaAccessToken(oktaAuth) {
  if (!oktaAuth) {
    return null;
  }

  const syncToken = oktaAuth.getAccessToken();
  if (syncToken) {
    return syncToken;
  }

  const tokens = await oktaAuth.tokenManager.getTokens();
  return tokens?.accessToken?.accessToken ?? null;
}
